import { Button, message, Modal, Spin } from 'antd';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './index.scss';
import couponApi from '@/api/coupon';
import { OnlineCouponItem } from '@/typings/allType';
import { handleExportCodes, handleExportUsageData } from '@/utils/publicMethod';
import { useAliveController } from 'react-activation';
function CouponDetail() {
    const link = useNavigate();
    const onlineCoupon = new URLSearchParams(useLocation().search).get('st') === 'coupon';
    const cId = new URLSearchParams(useLocation().search).get('stv');
    const [opModal, setOpModal] = useState(false);
    const [uploadStatus, setUploadStatus] = useState<'' | 'exportCodes' | 'exportUseData'>('');
    const [loadingStatus, setLoadingStatus] = useState<'' | 'get' | 'pause'>('get');
    const [coupon, setCouponDetail] = useState<OnlineCouponItem | null>(null);
    const getCouponInfo = async () => {
        if (!cId) return;
        try {
            const res = await couponApi.getCouponDetail(onlineCoupon ? 'coupon' : 'voucher', window.atob(cId));
            setCouponDetail({
                ...res.data,
                id: onlineCoupon ? res.data.couponId : res.data.voucherId,
                title: onlineCoupon ? res.data.couponName : res.data.voucherName,
                totalTask: onlineCoupon ? res.data.totalTask : res.data.usedNumber,
                promotionInformationList: onlineCoupon
                    ? res.data.promotionInformationList
                    : [
                          {
                              minTask: res.data.minTask,
                              discountType: res.data.discountType,
                              fixedDiscount: res.data.fixedDiscount,
                              percentageDiscount: res.data.percentageDiscount,
                              usedNum: res.data.usedNumber,
                              taskAmount: res.data.totalValue,
                          },
                      ],
            });
        } catch (error: any) {
            message.error(error);
            setCouponDetail(null);
        } finally {
            setLoadingStatus('');
        }
    };
    useEffect(() => {
        cId && getCouponInfo();
    }, []);
    const { drop } = useAliveController();
    const pause = async () => {
        if (!cId) return;
        setLoadingStatus('pause');
        try {
            await couponApi.pauseCoupon(onlineCoupon ? 'coupon' : 'voucher', window.atob(cId));
            setOpModal(false);
            coupon && setCouponDetail({ ...coupon, status: 'Expired' });
            drop(onlineCoupon ? 'OnlineCoupons' : 'VoucherCodes');
        } catch (error: any) {
            message.error(error);
        } finally {
            setLoadingStatus('');
        }
    };
    return (
        <div className="page-main coupon-detail">
            {!loadingStatus && coupon ? (
                <>
                    <div className="page-title flex-between">
                        <div style={{ fontFamily: 'SemiBold' }}>
                            <img
                                className="back-icon"
                                src={require('@/assets/images/back-icon.png')}
                                alt="back-icon"
                                onClick={() => {
                                    link(-1);
                                }}
                            />
                            {onlineCoupon ? 'Coupon Details' : 'Voucher Code Details'}
                        </div>
                        <div>
                            {(coupon.status === 'Active' || coupon.status === 'Not Started') && (
                                <Button
                                    type="primary"
                                    className="danger-btn"
                                    danger
                                    style={{ margin: '0 16px 0 auto' }}
                                    onClick={() => setOpModal(true)}
                                >
                                    Pause
                                </Button>
                            )}
                            {!onlineCoupon && !coupon.isFixedCode && (
                                <Button
                                    type="primary"
                                    size="small"
                                    style={{
                                        width: 157,
                                        height: 40,
                                        borderRadius: 8,
                                        marginRight: 16,
                                    }}
                                    loading={uploadStatus === 'exportCodes'}
                                    onClick={() => {
                                        setUploadStatus('exportCodes');
                                        handleExportCodes(coupon.id, coupon.title, () => {
                                            setUploadStatus('');
                                        });
                                    }}
                                >
                                    Export Codes
                                </Button>
                            )}
                            <Button
                                type="primary"
                                size="small"
                                style={{
                                    width: 190,
                                    height: 40,
                                    borderRadius: 8,
                                }}
                                loading={uploadStatus === 'exportUseData'}
                                onClick={() => {
                                    setUploadStatus('exportUseData');
                                    handleExportUsageData(
                                        onlineCoupon ? 'coupon' : 'voucher',
                                        coupon.id,
                                        coupon.title,
                                        () => {
                                            setUploadStatus('');
                                        }
                                    );
                                }}
                            >
                                Export Usage Data
                            </Button>
                        </div>
                    </div>
                    <div className="top-card">
                        <div className="flex-between">
                            <div className="coupon-tit">{coupon.title}</div>
                            <div
                                className={`coupon-status flex-center ${
                                    coupon.status === 'Not Started'
                                        ? 'not-start'
                                        : coupon.status === 'Active'
                                        ? 'active'
                                        : ''
                                }`}
                            >
                                {coupon.status}
                            </div>
                        </div>
                        <div className="flex-left">
                            {!onlineCoupon && (
                                <div className="coupon-info">
                                    <div className="c-into-tit">Discount Code</div>
                                    <div className="c-into-tip">
                                        {coupon.isFixedCode ? coupon.discountCode : `${coupon.quantity} unique codes`}
                                    </div>
                                </div>
                            )}
                            <div className="coupon-info">
                                <div className="c-into-tit">Creation Date</div>
                                <div className="c-into-tip">{window.utils.formatTimeMDY(coupon.createTime)}</div>
                            </div>
                            <div className="coupon-info">
                                <div className="c-into-tit">Validity</div>
                                <div className="c-into-tip">
                                    {coupon.validityType === 'permanentlyValid'
                                        ? 'Permanently valid'
                                        : `${window.utils.formatTimeMDY(
                                              coupon.beginDate
                                          )} - ${window.utils.formatTimeMDY(coupon.endDate)}`}
                                </div>
                            </div>
                        </div>
                        <div className="c-into-tip" style={{ margin: '16px 0' }}>
                            {coupon.description}
                        </div>
                        <div className="flex-between c-numBox">
                            <div className="c-numBox-item">
                                <div className="c-into-tip">{onlineCoupon ? 'Quantity' : 'Redemption Count'}</div>
                                <div className="c-num-val">
                                    {onlineCoupon ? coupon.quantity : coupon.redemptionCount}
                                </div>
                            </div>
                            <div className="c-numBox-item">
                                <div className="c-into-tip">Used ratio</div>
                                <div className="c-num-val">
                                    {!Number(coupon.totalTask)
                                        ? '0.00'
                                        : ((Number(coupon.totalTask) / Number(coupon.quantity)) * 100).toFixed(2)}
                                    %
                                </div>
                            </div>
                            <div className="c-numBox-item">
                                <div className="c-into-tip">
                                    {onlineCoupon
                                        ? 'Total task units linked to this coupon or voucher'
                                        : 'Total task Units'}
                                </div>
                                <div className="c-num-val">{coupon.totalTask}</div>
                            </div>
                            <div className="c-numBox-item">
                                <div className="c-into-tip">
                                    {onlineCoupon
                                        ? 'Total Value of tasks using this coupon or voucher'
                                        : 'Total amount of tasks involved'}
                                </div>
                                <div className="c-num-val">${coupon.totalValue}</div>
                            </div>
                        </div>
                    </div>
                    <div className="top-card">
                        <div className="coupon-titM">Promotion Information</div>
                        {coupon.promotionInformationList.map((item, i) => {
                            return (
                                <div className="promotion-card" key={`promotion-${i}`}>
                                    <div
                                        className="flex-between"
                                        style={{ alignItems: 'flex-start', marginBottom: 24 }}
                                    >
                                        <div className="coupon-titS">
                                            {item.discountType === 'noFees'
                                                ? 'No Threshold'
                                                : `Min Task ${item.minTask || 0}`}
                                            , Discount{' '}
                                            {item.discountType === 'noFees'
                                                ? 'No-Fees'
                                                : item.discountType === 'fixedAmount'
                                                ? '$' + item.fixedDiscount
                                                : item.percentageDiscount + '%'}
                                        </div>
                                        {Number(item.usedNum) > 0 &&
                                            (Number(item.usedNum) / Number(item.discountCount || coupon.quantity)) *
                                                100 >=
                                                100 && <span className="full-btn flex-center">Fully Redeemed</span>}
                                    </div>
                                    <div className="flex-left">
                                        <div className="used-info">
                                            Used
                                            <span className="used-min">{item.usedNum}</span>
                                        </div>
                                        <div className="used-info">
                                            Used Ratio
                                            <span className="used-min">
                                                {!Number(item.usedNum)
                                                    ? '0.00'
                                                    : (
                                                          (Number(item.usedNum) /
                                                              Number(item.discountCount || coupon.quantity)) *
                                                          100
                                                      ).toFixed(2)}
                                                %
                                            </span>
                                        </div>
                                        <div className="used-info">
                                            Total amount of tasks involved
                                            <span className="used-min">${item.taskAmount}</span>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    {onlineCoupon && coupon.smsNotification && (
                        <div className="top-card">
                            <div className="coupon-titM">SMS Notification Content</div>
                            <div className="c-into-tip" style={{ marginTop: 10 }}>
                                {coupon.notificationMessage}
                            </div>
                        </div>
                    )}
                </>
            ) : (
                <div className="no-data flex-center">{loadingStatus === 'get' ? <Spin /> : 'No data'}</div>
            )}
            {/* opeation modal */}
            <Modal
                width={440}
                maskClosable={false}
                centered={true}
                open={opModal}
                onCancel={() => setOpModal(false)}
                closeIcon={<img src={require('@/assets/images/Icons_Cross.png')} style={{ width: 24, height: 24 }} />}
            >
                <div className="modal-title" style={{ marginTop: 37 }}>
                    Expire coupons?
                </div>
                <div className="modal-tip tip-font-16">
                    All unused coupons will immediately expire, and this action cannot be undone.
                    <br />
                    <br />
                    Coupons that have already been redeemed will remain valid and cannot be reversed.
                </div>
                <div className="flex-center" style={{ marginTop: 30, columnGap: 20 }}>
                    <Button style={{ width: 138, height: 46 }} onClick={() => setOpModal(false)} className="cancel-btn">
                        Cancel
                    </Button>
                    <Button
                        style={{ width: 138, height: 46 }}
                        danger
                        loading={loadingStatus === 'pause'}
                        type="primary"
                        onClick={pause}
                    >
                        Pause
                    </Button>
                </div>
            </Modal>
        </div>
    );
}

export default CouponDetail;
